import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineClipboardSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    viewBox="0 0 44 44"
    {...props}
  >
    <path
      fill="#fff"
      d="M30 39.75c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M.75 7.25v32.5A3.25 3.25 0 0 0 4 43h19.293c-4.703-2.431-7.918-7.34-7.918-13 0-8.077 6.548-14.625 14.625-14.625 2.335 0 4.542.547 6.5 1.52V7.25A3.25 3.25 0 0 0 33.25 4H4A3.25 3.25 0 0 0 .75 7.25"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M23.5 8.875h-9.75a4.062 4.062 0 1 1 0-8.125h9.75a4.062 4.062 0 1 1 0 8.125"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M27.481 4h5.769a3.25 3.25 0 0 1 3.25 3.25v8.125M9.769 4H4A3.25 3.25 0 0 0 .75 7.25v32.5A3.25 3.25 0 0 0 4 43h17.875"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.5 8.875h-9.75a4.062 4.062 0 1 1 0-8.125h9.75a4.062 4.062 0 1 1 0 8.125M30 39.75c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75M43 43l-6.105-6.106"
    />
  </svg>
);
export default SvgStreamlineClipboardSearch;
